<div class="mx-auto max-w-(--breakpoint-2xl)">
  @if (suppliersPage) {
    <app-data-table
      (route)="this.handleRoute($event)"
      [title]="'Suppliers'"
      [dataPage]="suppliersPage"
      [columns]="tableColumns"
      [rowActions]="rowActions"
    >
      <div header class="flex w-full flex-row items-center justify-end gap-3">
        <a routerLink="/suppliers/create"
           class="h-12 text-theme-sm shadow-theme-xs inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-4 py-2.5 font-medium
          text-gray-700 hover:bg-gray-50 hover:text-gray-800 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-white/[0.03] dark:hover:text-gray-200">
          <lucide-icon [name]="PlusIcon"></lucide-icon>
          Add Supplier
        </a>
      </div>
    </app-data-table>
  }
</div>
